<!--
	HelpPage.svelte
-->

<script>
	import { onMount } from 'svelte';
    import { fly, fade } from 'svelte/transition';

    // TCARE components
    import PageBanner from '../../components/common/PageBanner.svelte';

    // SMUI components
    import Checkbox from '@smui/checkbox';

    $: isShowingUserTips = false;

    onMount(() => {
        checkForUserTipsCookie();
    })

    const checkForUserTipsCookie = () => {
        console.log('checkForUserTipsCookie');
        let vals = document.cookie.split('; ');
        isShowingUserTips = !vals.find(val => val.startsWith('hideUserTips'))
    }

    // user will actually write and delete the cookie
    const onShowUserTipsClick = () => {
        console.log('onShowUserTipsClick');
        let vals = document.cookie.split('; ');
        isShowingUserTips = !isShowingUserTips;
        console.log('isShowingUserTips is now: ' + isShowingUserTips);

        if (isShowingUserTips) {
            deleteUserTipsCookie();
        } else {
            writeUserTipsCookie();
        }
    }

    const deleteUserTipsCookie = () => {
        let vals = document.cookie.split('; ');
        console.log('deleteUserTipsCookie');
        if (vals.find(val => val.startsWith('hideUserTips'))) {
            console.log('found hideUserTips - deleting');
            document.cookie = "hideUserTips=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        } else {
            console.log('did not find hideUserTips');
        }
        console.log('cookie after DELETE: ' + document.cookie);
    }

    const writeUserTipsCookie = () => {
        let vals = document.cookie.split('; ');
        console.log('writeUserTipsCookie');
        if (!vals.find(val => val.startsWith('hideUserTips'))) {
            document.cookie = 'hideUserTips=true; ';
        }
        console.log('cookie after WRITE: ' + document.cookie);
    }

    


</script>

<style>
</style>

<div class="page-content help-page" in:fly="{{ x: 200, duration: 500 }}" out:fade="{{ duration: 250 }}">
    <div class="spacer-h-25"></div>
    <PageBanner title="Help for TCARE Connect"/>
    <div class="spacer-h-25"></div>

    <div class="flex-row jc-start">
        <Checkbox bind:checked={isShowingUserTips} on:click={onShowUserTipsClick} />
        Show user tips on Explorer Page
    </div>

</div>

